import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

const categoryImages: Record<string, string> = {
  'Shoes': 'https://readdy.ai/api/search-image?query=Stylish%20sneakers%20neatly%20arranged%20on%20a%20warm%20wooden%20surface%2C%20minimal%20product%20photography%20with%20soft%20natural%20light%2C%20cream%20background%2C%20clean%20editorial%20style%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-shoes&orientation=landscape',
  'Hoodies / Sweaters': 'https://readdy.ai/api/search-image?query=Premium%20hoodie%20neatly%20folded%20on%20a%20warm%20wooden%20table%2C%20soft%20cozy%20natural%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-hoodies&orientation=landscape',
  'T-Shirts': 'https://readdy.ai/api/search-image?query=Stack%20of%20premium%20cotton%20t-shirts%20in%20neutral%20tones%20on%20a%20warm%20wooden%20surface%2C%20soft%20studio%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-tshirts&orientation=landscape',
  'Jackets': 'https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20hung%20on%20a%20warm%20wooden%20hanger%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-jackets&orientation=landscape',
  'Pants / Shorts': 'https://readdy.ai/api/search-image?query=Premium%20denim%20jeans%20and%20shorts%20neatly%20folded%20on%20a%20warm%20wooden%20surface%2C%20soft%20natural%20light%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-pants&orientation=landscape',
  'Headwear': 'https://readdy.ai/api/search-image?query=Stylish%20caps%20and%20beanies%20arranged%20on%20a%20warm%20wooden%20shelf%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-headwear&orientation=landscape',
  'Sets': 'https://readdy.ai/api/search-image?query=Matching%20fashion%20outfit%20set%20neatly%20laid%20out%20on%20a%20warm%20wooden%20surface%2C%20soft%20natural%20light%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-sets&orientation=landscape',
  'Underwear / Underpants': 'https://readdy.ai/api/search-image?query=Premium%20cotton%20basics%20neatly%20folded%20on%20a%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-underwear&orientation=landscape',
  'Jersey': 'https://readdy.ai/api/search-image?query=Sports%20jersey%20neatly%20displayed%20on%20a%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-jersey&orientation=landscape',
  'Accessories': 'https://readdy.ai/api/search-image?query=Elegant%20watches%20and%20jewelry%20arranged%20on%20a%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-accessories&orientation=landscape',
  'Bags': 'https://readdy.ai/api/search-image?query=Premium%20leather%20backpack%20and%20tote%20bag%20on%20a%20warm%20wooden%20table%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-bags&orientation=landscape',
  'Belts': 'https://readdy.ai/api/search-image?query=Premium%20leather%20belts%20neatly%20arranged%20on%20a%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-belts&orientation=landscape',
  'Perfumes': 'https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20arranged%20on%20a%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-perfumes&orientation=landscape',
  'Other Stuff': 'https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20products%20neatly%20arranged%20on%20a%20warm%20wooden%20surface%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20cream%20background%2C%20no%20text%20no%20logos&width=400&height=280&seq=cat-img-other&orientation=landscape',
};

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCategoryClick = (url: string) => {
    setIsOpen(false);
    setIsMobileOpen(false);
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background-50 border-b-2 border-background-300/80">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="font-heading text-xl font-bold text-foreground-950 tracking-tight">
              VigorBuy
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-sm font-semibold text-foreground-900 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
              Home
            </Link>

            {/* Categories Dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-1.5 text-sm font-semibold text-foreground-900 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>Categories</span>
                <i className={`ri-arrow-down-s-line transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isOpen && (
                <div className="absolute top-full left-0 mt-2 w-72 bg-background-50 rounded-2xl border-2 border-background-300/80 shadow-lg py-2 z-50">
                  <div className="max-h-80 overflow-y-auto">
                    {categories.map((cat) => (
                      <button
                        key={cat.name}
                        onClick={() => handleCategoryClick(cat.url)}
                        className="w-full text-left px-4 py-3 text-sm text-foreground-800 hover:bg-background-100 hover:text-foreground-950 transition-colors flex items-center justify-between cursor-pointer"
                      >
                        <span className="font-medium">{cat.name}</span>
                        <i className="ri-external-link-line text-xs text-foreground-400"></i>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link to="/guide/vigorbuy-spreadsheet-complete-guide" className="text-sm font-semibold text-foreground-900 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
              Shopping Guide
            </Link>
            <Link to="/#safety" className="text-sm font-semibold text-foreground-900 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
              Safety
            </Link>
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 text-sm font-semibold text-foreground-900 border-2 border-foreground-300 rounded-full hover:border-foreground-500 hover:text-foreground-950 transition-all whitespace-nowrap cursor-pointer"
            >
              VigorBuy Sheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2.5 text-sm font-bold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap flex items-center gap-1.5 cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-900 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t-2 border-background-300/80 px-4 pb-6 max-h-[80vh] overflow-y-auto">
          {/* Quick Links */}
          <div className="flex flex-col gap-1 pt-4 pb-2">
            <Link to="/" onClick={() => setIsMobileOpen(false)} className="py-3 text-base font-semibold text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer flex items-center gap-2">
              <i className="ri-home-4-line"></i> Home
            </Link>
            <Link to="/guide/vigorbuy-spreadsheet-complete-guide" onClick={() => setIsMobileOpen(false)} className="py-3 text-base font-semibold text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer flex items-center gap-2">
              <i className="ri-book-open-line"></i> Shopping Guide
            </Link>
            <Link to="/#safety" onClick={() => setIsMobileOpen(false)} className="py-3 text-base font-semibold text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer flex items-center gap-2">
              <i className="ri-shield-check-line"></i> Safety
            </Link>
          </div>

          {/* Category Grid in Mobile */}
          <div className="border-t-2 border-background-300/80 my-3 pt-4">
            <p className="text-xs font-bold text-foreground-500 uppercase tracking-wider px-1 pb-3">Browse Categories</p>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleCategoryClick(cat.url)}
                  className="flex items-center gap-2 py-2.5 px-3 text-sm font-medium text-foreground-700 hover:text-foreground-950 hover:bg-background-100 rounded-xl transition-colors text-left cursor-pointer"
                >
                  <span className="truncate">{cat.name}</span>
                  <i className="ri-external-link-line text-xs text-foreground-400 flex-shrink-0"></i>
                </button>
              ))}
            </div>
          </div>

          {/* CTA on Mobile */}
          <div className="border-t-2 border-background-300/80 my-3 pt-4 flex flex-col gap-2">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="py-3.5 text-center text-base font-semibold text-foreground-900 border-2 border-foreground-300 rounded-full hover:border-foreground-500 transition-all whitespace-nowrap cursor-pointer">
              VigorBuy Sheet
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="py-3.5 text-center text-base font-bold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2">
              Buy It Now <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}

export { categoryImages };